import React from 'react'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useSearchBusinessProfilesQuery } from '../../api/dataApi';
import CryptoJS from 'crypto-js';

export default function AiSetupContent() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const secretKey = 'j5wbjG3jNJMCSI9';
    
    const decryptText = (ciphertext) => {
        const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
        const original = bytes.toString(CryptoJS.enc.Utf8);
        return original;
    };

    const decryptEmail = decryptText(queryParams.get('ue') || "") || "";

    const { data: businessProfiles, error, isLoading } = useSearchBusinessProfilesQuery(decryptEmail);

    const isVideoParams = queryParams.get('video-ads') || queryParams.get('video-avatars') || queryParams.get('video-templates') || queryParams.get('video-scripts') || queryParams.get('video-hooks') || queryParams.get('video-conversion');
    const isStaticParams = queryParams.get('static-ads') || queryParams.get('static-templates') || queryParams.get('static-text') || queryParams.get('static-editor') || queryParams.get('static-bulk');
    const isAdParams = queryParams.get('ad-campaigns') || queryParams.get('ad-channels') || queryParams.get('ad-targeting') || queryParams.get('ad-optimization') || queryParams.get('ad-reports') || queryParams.get('ad-copilot');
    const videoAds = queryParams.get('video-ads') ?? (isVideoParams && businessProfiles?.data?.data?.videoAds);
    const videoAvatars = queryParams.get('video-avatars') ?? (isVideoParams && businessProfiles?.data?.data?.videoAvatars);
    const videoTemplates = queryParams.get('video-templates') ?? (isVideoParams && businessProfiles?.data?.data?.videoTemplates);
    const videoScripts = queryParams.get('video-scripts') ?? (isVideoParams && businessProfiles?.data?.data?.videoScripts);
    const videoHooks = queryParams.get('video-hooks') ?? (isVideoParams && businessProfiles?.data?.data?.videoHooks);
    const videoConversion = queryParams.get('video-conversion') ?? (isVideoParams && businessProfiles?.data?.data?.videoConversion);
    const staticAds = queryParams.get('static-ads') ?? (isStaticParams && businessProfiles?.data?.data?.staticAds);
    const staticTemplates = queryParams.get('static-templates') ?? (isStaticParams && businessProfiles?.data?.data?.staticTemplates);
    const staticText = queryParams.get('static-text') ?? (isStaticParams && businessProfiles?.data?.data?.staticText);
    const staticEditor = queryParams.get('static-editor') ?? (isStaticParams && businessProfiles?.data?.data?.staticEditor);
    const staticBulk = queryParams.get('static-bulk') ?? (isStaticParams && businessProfiles?.data?.data?.staticBulk);
    const adCampaigns = queryParams.get('ad-campaigns') ?? (isAdParams && businessProfiles?.data?.data?.adCampaigns);
    const adChannels = queryParams.get('ad-channels') ?? (isAdParams && businessProfiles?.data?.data?.adChannels);
    const adTargeting = queryParams.get('ad-targeting') ?? (isAdParams && businessProfiles?.data?.data?.adTargeting);
    const adOptimization = queryParams.get('ad-optimization') ?? (isAdParams && businessProfiles?.data?.data?.adOptimization);
    const adReports = queryParams.get('ad-reports') ?? (isAdParams && businessProfiles?.data?.data?.adReports);
    const adCopilot = queryParams.get('ad-copilot') ?? (isAdParams && businessProfiles?.data?.data?.adCopilot);

    const isVideoParamsALL = videoAds || videoAvatars || videoTemplates || videoScripts || videoHooks || videoConversion;
    const isStaticParamsALL = staticAds || staticTemplates || staticText || staticEditor || staticBulk;
    const isAdParamsALL = adCampaigns || adChannels || adTargeting || adOptimization || adReports || adCopilot;
    const socials = queryParams.get('ad-channels-value') ? queryParams.get('ad-channels-value').split(',') : [];


  return (
    <>
               {/* {(isVideoParamsALL || isStaticParamsALL || isAdParamsALL) && */}
                    <>
                        <div className="plan-ai">
                
                            {/* {queryParams.get('video-ads') && */}
                            {(isVideoParamsALL || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                <div className="plan-ai-wrap">
                                    <div className="plan-ai-wrap__title">
                                        AI video ads
                                    </div>
                                    {(videoAds || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai1.webp`} alt="" />
                                            <div>
                                                <h4>Viral video ads</h4>
                                                <p>UGC-style video ads generation</p>
                                            </div>
                                        </div>
                                    }
                                    {(videoAvatars || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai2.webp`} alt="" />
                                            <div>
                                                <h4>Hyper-realistic avatars</h4>
                                                <p>30+ lifelike AI avatars for ads</p>
                                            </div>
                                        </div>
                                    }
                                    {(videoTemplates || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai3.webp`} alt="" />
                                            <div>
                                                <h4>Dynamic templates</h4>
                                                <p>Quality templates with rich transitions</p>
                                            </div>
                                        </div>
                                    }
                                    {(videoScripts || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai4.webp`} alt="" />
                                            <div>
                                                <h4>Sales-focused scripts</h4>
                                                <p>Proven AI-powered scripts</p>
                                            </div>
                                        </div>
                                    }
                                    {(videoHooks || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai5.webp`} alt="" />
                                            <div>
                                                <h4>Engaging hooks & CTAs</h4>
                                                <p>Higher CTR and better results with AI</p>
                                            </div>
                                        </div>
                                    }
                                    {(videoConversion || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai6.webp`} alt="" />
                                            <div>
                                                <h4>AI conversion widget</h4>
                                                <p>AI copilot to guide you through ad creation</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }

                            {/* } */}
                            {/* {queryParams.get('static-ads') && */}
                            {(isStaticParamsALL ||  (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                <div className="plan-ai-wrap">
                                    <div className="plan-ai-wrap__title">
                                        AI static ads
                                    </div>
                                    {(staticAds || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai7.webp`} alt="" />
                                            <div>
                                                <h4>AI-powered static ads</h4>
                                                <p>Selling static ad in less than 1 minute</p>
                                            </div>
                                        </div>
                                    }
                                    {(staticTemplates || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai8.webp`} alt="" />
                                            <div>
                                                <h4>100+ tested templates</h4>
                                                <p>AI-picked and regularly updated</p>
                                            </div>
                                        </div>
                                    }
                                    {(staticText || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai9.webp`} alt="" />
                                            <div>
                                                <h4>AI text tools</h4>
                                                <p>Engaging texts and CTAs managed by AI</p>
                                            </div>
                                        </div>
                                    }
                                    {(staticEditor || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL) )&&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai10.webp`} alt="" />
                                            <div>
                                                <h4>Drag-n-drop editing</h4>
                                                <p>AI customization made simple</p>
                                            </div>
                                        </div>
                                    }

                                    {(staticBulk || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai11.webp`} alt="" />
                                            <div>
                                                <h4>Bulk creation</h4>
                                                <p>Multiple ad creation for A/B testing purposes</p>
                                            </div>
                                        </div>
                                    }

                                </div>
                            }

                            {/* } */}

                            {/* {queryParams.get('ad-campaigns') && */}
                            {(isAdParamsALL || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                <div className="plan-ai-wrap">
                                    <div className="plan-ai-wrap__title">
                                        AI ad campaigns
                                    </div>
                                    {(adCampaigns || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai12.webp`} alt="" />
                                            <div>
                                                <h4>Smart AI campaigns</h4>
                                                <p>Less than 15 minutes to launch AI campaign</p>
                                            </div>
                                        </div>
                                    }
                                    {(adChannels  || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <div className="plan-ai-item__images">
                                                {socials.length > 0 ? (socials.map((social, index) => (
                                                    <img style={{ border: social == 'Google' ? '1rem solid #F2F4F6' : '', background: social == 'Google' ? '#FFF' : '' }} src={process.env.PUBLIC_URL + `/img/SVG_Goals/${social}.svg`} alt="" />
                                                ))) : (
                                                    <>

                                                        <img style={{ border: '1rem solid #F2F4F6', background: '#fff' }} src={process.env.PUBLIC_URL + `/img/SVG_Goals/Google.svg`} alt="" />
                                                        <img src={process.env.PUBLIC_URL + `/img/SVG_Goals/TikTok.svg`} alt="" />
                                                        <img src={process.env.PUBLIC_URL + `/img/SVG_Goals/Facebook.svg`} alt="" />
                                                        <img src={process.env.PUBLIC_URL + `/img/SVG_Goals/Instagram.svg`} alt="" />
                                                    </>
                                                )}
                                            </div>


                                            <div>
                                                <h4>Ad platforms setup</h4>
                                                <p>AI handles platform setup seamlessly</p>
                                            </div>
                                        </div>
                                    }
                                    {(adTargeting || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai14.webp`} alt="" />
                                            <div>
                                                <h4>Smart AI targeting</h4>
                                                <p>AI finds the best buyers for your product</p>
                                            </div>
                                        </div>
                                    }
                                    {(adOptimization || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai15.webp`} alt="" />
                                            <div>
                                                <h4>AI-optimized ads</h4>
                                                <p>Mistake-free ad campaigns run with AI</p>
                                            </div>
                                        </div>
                                    }
                                    {(adReports || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai6.webp`} alt="" />
                                            <div>
                                                <h4>Real-time reporting</h4>
                                                <p>24/7 personalized AI-driven insights</p>
                                            </div>
                                        </div>
                                    }


                                    {(adCopilot || (!isVideoParamsALL && !isStaticParamsALL && !isAdParamsALL)) &&
                                        <div className="plan-ai-item">
                                            <img src={process.env.PUBLIC_URL + `/img/plan/ai17.webp`} alt="" />
                                            <div>
                                                <h4>AI ads copilot</h4>
                                                <p>AI sets up and boosts your ads</p>
                                            </div>
                                        </div>
                                    }

                                </div>
                            }

                            {/* } */}

                        </div>
                    </>
                {/* } */}
                </>
  )
}
